import React, { FC, useMemo } from 'react';
import classNames from 'classnames';

import Icon from 'vibo-ui/Icon';

import { getEventTypeIcon } from 'services/events/iconType';

import { EventTypeIconProps } from './interfaces';

const EventTypeIcon: FC<EventTypeIconProps> = ({ type, className }) => {
  const eventIcon = useMemo(() => getEventTypeIcon(type), [type]);

  if (!eventIcon) {
    return null;
  }

  return <Icon className={classNames('eventTypeIcon', className)} icon={eventIcon} />;
};

export default EventTypeIcon;
